import { FC, ReactNode } from 'react';

import { Skeleton, SxProps } from '@mui/material';

type AnimationType = 'pulse' | 'wave' | false;

export type LoadSkeletonProps = {
  children?: ReactNode;
  animation?: AnimationType;
  isLoading: boolean;
  width?: number | string;
  height?: number | string;
  sx?: SxProps;
};

export const LoadSkeleton: FC<LoadSkeletonProps> = ({
  children,
  isLoading,
  animation = 'pulse',
  width = 180,
  height = 32,
  sx,
}) => {
  return (
    <>{isLoading ? <Skeleton animation={animation} width={width} height={height} sx={sx} /> : children}</>
  );
};
